<template>
  <v-container>
    <!---NairobiSkyLine-->
    <v-row>
      <v-col>
        <v-img height="250" cover src="/images/nairobi3.jpg"></v-img>
      </v-col>
    </v-row>
    <!--Our History-->
    <v-row>
      <v-col>
        <h1 class="text-purple text-capitalize">A brief history of ITNomads</h1>
        <p class="text-justify">
          ITNomads was started by a group of 3 friends based in different
          countries within the East African region namely Kenya, Uganda and
          Tanzania. These three friends had an idea to revolutionize varous
          industries which they were part of using Information Technology. Over
          the years these individuals have developed a broad skillset in
          different programming languages and other technical and social skills
          that they have honed to deliver various services. Many businesses have
          continued to benefit from the services the company offers and this has
          improved the rate of overall customer satisfaction.
        </p>
      </v-col>
    </v-row>
    <!---Our Staff-->
    <v-row>
      <v-col>
        <h1 class="text-purple text-capitalize">Our Team</h1>
        <p class="text-justify">
          ITN has a team of highly qualified professionals with a vast array of
          experience in the latest technologies. Innovation is at the core of
          all our operations. Collaboration within our different teams has
          motivated us to deliver the best availlable software and services to
          our loyal customers. Connect with us on our LinkedIn page and you will
          not regret this decision.
        </p>
      </v-col>
    </v-row>
    <!---Our Mission---->
    <v-row>
      <v-col>
        <h1 class="text-purple text-capitalize">Our Mission</h1>
        <p class="text-justify">
          Our goal is to enable our customers excel in their respective markets
          by empowering them with the necessary software and digital
          tools.Eventually we hope to set up a presence in every city of the
          world to enable more customers benefit from accessing our cutting-edge
          solutions.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default{
        name:'About'
}
</script>
